
import React, { useEffect } from 'react';
import { Button, Col, Container, Row } from 'react-bootstrap';
import useModal from '../../hooks/useModal';
import GenericCard from '../../components/GenericCards/GenericCards';
import MedicalBalanceHistory from '../widgets/OutstandingPaymentBalance/MedicalBalanceModal'
import DentalBalanceHistory from '../widgets/OutstandingPaymentBalance/DentalBalanceModal'
import VisionBalanceHistory from '../widgets/OutstandingPaymentBalance/VisionBalanceModal'
import ShortTermDisabilityBalanceHistory from '../widgets/OutstandingPaymentBalance/ShortTermDisabilityBalanceModal'
import MedicalRetroBalanceHistory from '../widgets/OutstandingPaymentBalance/MedicalRetroBalanceModal'

const MissedBenefitPayments = () => {
  const [showMedicalBalance, handleShowMedicalBalance, handleCloseMedicalBalance] = useModal();
  const [showDentalBalance, handleShowDentalBalance, handleCloseDentalBalance] = useModal();
  const [showVisionBalance, handleShowVisionBalance, handleCloseVisionBalance] = useModal();
  const [showShortTermDisabilityBalance, handleShowShortTermDisabilityBalance, handleCloseShortTermDisabilityBalance] = useModal();
  const [showMedicalRetroBalance, handleShowMedicalRetroBalance, handleCloseMedicalRetroBalance] = useModal();

  // Function to calculate and update total arrear balances
  const updateTotalArrearBalances = () => {
    const arrearElements = document.querySelectorAll('.arrear-balance');
    let totalArrearBalances = 0;
    arrearElements.forEach((element) => {
      const text = element.textContent || '';
      totalArrearBalances += parseFloat(text.replace('$', ''));
    });

    const totalElement = document.querySelector('.total-arrear-balances') ?? document.createElement('div');
    totalElement.textContent = `$${totalArrearBalances.toFixed(2)}`;
      
  };

  // Function to calculate and update total retro balances
  const updateTotalRetroBalances = () => {
    const retroElements = document.querySelectorAll('.retro-balance');
    let totalRetroBalances = 0;
    retroElements.forEach((element) => {
      const text = element.textContent || '';
      totalRetroBalances += parseFloat(text.replace('$', ''));
    });

    const totalElement = document.querySelector('.total-retro-balances') ?? document.createElement('div');
    totalElement.textContent = `$${totalRetroBalances.toFixed(2)}`;
  };

  // useEffect to run the update functions after the component is rendered
  useEffect(() => {
    updateTotalArrearBalances();
    updateTotalRetroBalances();
  }, []);

  return (
    <Container className={'cnd-custom-container px-0 mt-11'}>
      <Container className={'px-7 px-lg-0 mb-11 mb-lg-12'}>
        <Row>
          <Col className={'col-12 col-lg-12'}>
            <h2 className={'text-sm-20-lg-24 mb-7 mb-lg-11'}>
              Outstanding Payment Balance
            </h2>
            <p className="text-caption lh-xs">
              Below is the current status of any benefit deductions you’ve
              missed and the amounts that are in the process of being recovered
              via payroll. For details on a given retro or arrear current
              balance, click the “View History” button at the end of the row.
            </p>
            <div className="custom-blockquote warning-bg warning lh-xs container">
              <div className="mb-0 text-ligther-grey">
                <span>
                  NOTE:The data displayed below is as of the current point in
                  time. It may be updated and/or corrected at any time based on
                  several factors, such as timing of payroll processing.
                </span>
              </div>
            </div>
          </Col>
        </Row>
      </Container>

      <GenericCard variant={'white'}>
        <Row className="m-0">
          <Col className="p-0 d-flex align-items-center">
            <h6 className="m-0 lh-xs text-sm-16-lg-20 mb-6">
              Current Payroll Arrear Balances
            </h6>
          </Col>
        </Row>

        <Row>
          <Col>
            <Row className={'d-none d-lg-flex border-bottom-dark-gray py-8'}>
              <Col className={'d-none d-lg-block col-lg-2 text-fs-6 m-0'}>
                Benefit
              </Col>
              <Col className={'col-lg-2 ps-6 m-0'}>
                <span className={'text-fs-6 ms-11'}>Deduct Tax</span>
              </Col>
              <Col className={'col-auto col-1 col-lg-2 text-fs-6 m-0'}>
                <span className={'text-fs-6'}>Last Payment Details</span>
              </Col>
              <Col className={'col-auto col-lg-2 text-fs-6 m-0'}>
                <span className={'text-fs-6'}>Outstanding Balances</span>
              </Col>
              <Col className={'col-lg-2 text-fs-6 m-0'}>
                <span className={'text-fs-6'}>Approx Remaining Payments</span>
              </Col>
              <Col className={'col-auto col-lg-2 text-fs-6 m-0'}>
                <span className={'text-fs-6'}></span>
              </Col>
            </Row>

            <Row
              className={
                'striped-rows-fixed-children px-8 py-11 px-lg-0 py-lg-8 d-flex flex-lg-row flex-wrap align-items-center border-bottom border-info'
              }
            >
              <Col
                className={
                  'px-0 px-lg-5 col-3 col-lg-2 order-0 h3 text-fs-6 m-0 fw-bold'
                }
              >
                Medical
              </Col>
              <Col
                className={
                  'col-3 col-lg-2 d-lg-flex align-items-start justify-content-lg-center order-1'
                }
              >
                <span className={'d-flex align-items-center h3 text-fs-6 m-0'}>
                  Before-Tax
                </span>
              </Col>
              <Col
                className={
                  'ms-auto m-lg-0 col-auto col-lg-2 order-2 order-lg-5 text-center'
                }
              >
                <div>
                  <Button
                    variant="primary"
                    size="sm"
                    onClick={handleShowMedicalBalance}
                  >
                    View History
                  </Button>
                  <MedicalBalanceHistory
                    show={showMedicalBalance}
                    handleClose={handleCloseMedicalBalance}
                  />
                </div>
              </Col>
              <Col
                className={
                  'd-flex d-lg-block align-items-center col-12 col-lg-2 order-3 py-6 px-5 mt-7 mt-lg-0 py-lg-0 text-end text-lg-center'
                }
              >
                <h2 className={'d-lg-none col-auto h6 text-fs-6 m-0 pb-lg-8'}>
                  Last Payment Details
                </h2>
                <span
                  className={'w-100 text-end text-lg-start h3 text-fs-6 m-0'}
                >
                  $47.94
                  <br />
                  <span className={'text-blue h3 text-fs-6 m-0'}>
                    01/09/2023
                  </span>
                </span>
              </Col>
              <Col
                className={
                  'd-flex d-lg-block align-items-center col-12 col-lg-2 order-4 order-lg-3 py-6 px-5 py-lg-0 text-end text-lg-center'
                }
              >
                <h2 className={'d-lg-none col-auto h6 text-fs-6 m-0 pb-lg-8'}>
                  Outstanding Balances
                </h2>
                <span
                  className={'arrear-balance w-100 text-end text-lg-start h3 text-fs-6 m-0'}
                >
                  $479.42
                </span>
              </Col>
              <Col
                className={
                  'd-flex d-lg-block align-items-center col-12 col-lg-2 order-5 order-lg-4 py-6 px-5 py-lg-0 text-end text-lg-center'
                }
              >
                <h2 className={'d-lg-none h6 text-fs-6 m-0'}>
                  Approx Remaining Payments
                </h2>
                <span
                  className={'w-100 text-end text-lg-center h3 text-fs-6 m-0'}
                >
                  11
                </span>
              </Col>
            </Row>
          </Col>
        </Row>

        <Row>
          <Col>
            <Row
              className={
                'striped-rows-fixed-children px-8 py-11 px-lg-0 py-lg-8 d-flex flex-lg-row flex-wrap align-items-center border-bottom border-info'
              }
            >
              <Col
                className={
                  'px-0 px-lg-5 col-3 col-lg-2 order-0 h3 text-fs-6 m-0 fw-bold'
                }
              >
                Dental
              </Col>
              <Col
                className={
                  'col-3 col-lg-2 d-lg-flex align-items-start justify-content-lg-center order-1'
                }
              >
                <span className={'d-flex align-items-center h3 text-fs-6 m-0'}>
                  Before-Tax
                </span>
              </Col>
              <Col
                className={
                  'ms-auto m-lg-0 col-auto col-lg-2 order-2 order-lg-5 text-center'
                }
              >
                <div>
                  <Button
                    variant="primary"
                    size="sm"
                    onClick={handleShowDentalBalance}
                  >
                    View History
                  </Button>
                  <DentalBalanceHistory
                    show={showDentalBalance}
                    handleClose={handleCloseDentalBalance}
                  />
                </div>
              </Col>
              <Col
                className={
                  'd-flex d-lg-block align-items-center col-12 col-lg-2 order-3 py-6 px-5 mt-7 mt-lg-0 py-lg-0 text-end text-lg-center'
                }
              >
                <h2 className={'d-lg-none col-auto h6 text-fs-6 m-0 pb-lg-8'}>
                  Last Payment Details
                </h2>
                <span
                  className={'w-100 text-end text-lg-start h3 text-fs-6 m-0'}
                >
                  $2.88
                  <br />
                  <span className={'text-blue h3 text-fs-6 m-0'}>
                    09/08/2023
                  </span>
                </span>
              </Col>
              <Col
                className={
                  'd-flex d-lg-block align-items-center col-12 col-lg-2 order-4 order-lg-3 py-6 px-5 py-lg-0 text-end text-lg-center'
                }
              >
                <h2 className={'d-lg-none col-auto h6 text-fs-6 m-0 pb-lg-8'}>
                  Outstanding Balances
                </h2>
                <span
                  className={'arrear-balance w-100 text-end text-lg-start h3 text-fs-6 m-0'}
                >
                  $28.76
                </span>
              </Col>
              <Col
                className={
                  'd-flex d-lg-block align-items-center col-12 col-lg-2 order-5 order-lg-4 py-6 px-5 py-lg-0 text-end text-lg-center'
                }
              >
                <h2 className={'d-lg-none h6 text-fs-6 m-0'}>
                  Approx Remaining Payments
                </h2>
                <span
                  className={'w-100 text-end text-lg-center h3 text-fs-6 m-0'}
                >
                  10
                </span>
              </Col>
            </Row>
          </Col>
        </Row>

        <Row>
          <Col>
            <Row
              className={
                'striped-rows-fixed-children px-8 py-11 px-lg-0 py-lg-8 d-flex flex-lg-row flex-wrap align-items-center border-bottom border-info'
              }
            >
              <Col
                className={
                  'px-0 px-lg-5 col-3 col-lg-2 order-0 h3 text-fs-6 m-0 fw-bold'
                }
              >
                Vision
              </Col>
              <Col
                className={
                  'col-3 col-lg-2 d-lg-flex align-items-start justify-content-lg-center order-1'
                }
              >
                <span className={'d-flex align-items-center h3 text-fs-6 m-0'}>
                  Before-Tax
                </span>
              </Col>
              <Col
                className={
                  'ms-auto m-lg-0 col-auto col-lg-2 order-2 order-lg-5 text-center'
                }
              >
                <div>
                  <Button
                    variant="primary"
                    size="sm"
                    onClick={handleShowVisionBalance}
                  >
                    View History
                  </Button>
                  <VisionBalanceHistory
                    show={showVisionBalance}
                    handleClose={handleCloseVisionBalance}
                  />
                </div>
              </Col>
              <Col
                className={
                  'd-flex d-lg-block align-items-center col-12 col-lg-2 order-3 py-6 px-5 mt-7 mt-lg-0 py-lg-0 text-end text-lg-center'
                }
              >
                <h2 className={'d-lg-none col-auto h6 text-fs-6 m-0 pb-lg-8'}>
                  Last Payment Details
                </h2>
                <span
                  className={'w-100 text-end text-lg-start h3 text-fs-6 m-0'}
                >
                  $0.74
                  <br />
                  <span className={'text-blue h3 text-fs-6 m-0'}>
                    01/09/2023
                  </span>
                </span>
              </Col>
              <Col
                className={
                  'd-flex d-lg-block align-items-center col-12 col-lg-2 order-4 order-lg-3 py-6 px-5 py-lg-0 text-end text-lg-center'
                }
              >
                <h2 className={'d-lg-none col-auto h6 text-fs-6 m-0 pb-lg-8'}>
                  Outstanding Balances
                </h2>
                <span
                  className={'arrear-balance w-100 text-end text-lg-start h3 text-fs-6 m-0'}
                >
                  $5.38
                </span>
              </Col>
              <Col
                className={
                  'd-flex d-lg-block align-items-center col-12 col-lg-2 order-5 order-lg-4 py-6 px-5 py-lg-0 text-end text-lg-center'
                }
              >
                <h2 className={'d-lg-none h6 text-fs-6 m-0'}>
                  Approx Remaining Payments
                </h2>
                <span
                  className={'w-100 text-end text-lg-center h3 text-fs-6 m-0'}
                >
                  8
                </span>
              </Col>
            </Row>
          </Col>
        </Row>

        <Row>
          <Col>
            <Row
              className={
                'striped-rows-fixed-children px-8 py-11 px-lg-0 py-lg-8 d-flex flex-lg-row flex-wrap align-items-center border-info'
              }
            >
              <Col
                className={
                  'px-0 px-lg-5 col-3 col-lg-2 order-0 h3 text-fs-6 m-0 fw-bold'
                }
              >
                Short-Term Disability
              </Col>
              <Col
                className={
                  'col-3 col-lg-2 d-lg-flex align-items-start justify-content-lg-center order-1'
                }
              >
                <span className={'d-flex align-items-center h3 text-fs-6 m-0'}>
                  Before-Tax
                </span>
              </Col>
              <Col
                className={
                  'ms-auto m-lg-0 col-auto col-lg-2 order-2 order-lg-5 text-center'
                }
              >
                <div>
                  <Button
                    variant="primary"
                    size="sm"
                    onClick={handleShowShortTermDisabilityBalance}
                  >
                    View History
                  </Button>
                  <ShortTermDisabilityBalanceHistory
                    show={showShortTermDisabilityBalance}
                    handleClose={handleCloseShortTermDisabilityBalance}
                  />
                </div>
              </Col>
              <Col
                className={
                  'd-flex d-lg-block align-items-center col-12 col-lg-2 order-3 py-6 px-5 mt-7 mt-lg-0 py-lg-0 text-end text-lg-center'
                }
              >
                <h2 className={'d-lg-none col-auto h6 text-fs-6 m-0 pb-lg-8'}>
                  Last Payment Details
                </h2>
                <span
                  className={'w-100 text-end text-lg-start h3 text-fs-6 m-0'}
                >
                  $3.28
                  <br />
                  <span className={'text-blue h3 text-fs-6 m-0'}>
                    01/09/2023
                  </span>
                </span>
              </Col>
              <Col
                className={
                  'd-flex d-lg-block align-items-center col-12 col-lg-2 order-4 order-lg-3 py-6 px-5 py-lg-0 text-end text-lg-center'
                }
              >
                <h2 className={'d-lg-none col-auto h6 text-fs-6 m-0 pb-lg-8'}>
                  Outstanding Balances
                </h2>
                <span
                  className={'arrear-balance w-100 text-end text-lg-start h3 text-fs-6 m-0'}
                >
                  $24.03
                </span>
              </Col>
              <Col
                className={
                  'd-flex d-lg-block align-items-center col-12 col-lg-2 order-5 order-lg-4 py-6 px-5 py-lg-0 text-end text-lg-center'
                }
              >
                <h2 className={'d-lg-none h6 text-fs-6 m-0'}>
                  Approx Remaining Payments
                </h2>
                <span
                  className={'w-100 text-end text-lg-center h3 text-fs-6 m-0'}
                >
                  8
                </span>
              </Col>
            </Row>
            <Row
              className={
                'striped-rows-fixed-children px-8 py-11 px-lg-0 py-lg-8 d-flex flex-lg-row flex-wrap align-items-center border-top border-info'
              }
            >
              <Col className={'col-lg-6 text-fs-6 m-0'}>
                <span className={'fw-bold text-fs-6'}>Total</span>
              </Col>
              <Col className={'col-lg-2 text-end text-lg-center h3 text-fs-6 m-0'}>
                <span className={'total-arrear-balances fw-bold text-fs-6'}>$700.00</span>
              </Col>
            </Row>
          </Col>
        </Row>
      </GenericCard>

      <br />
      <br />

      <GenericCard variant={'white'}>
        <Row className="m-0">
          <Col className="p-0 d-flex align-items-center">
            <h6 className="m-0 lh-xs text-sm-16-lg-20 mb-6">
              Current Payroll Retro Balances
            </h6>
          </Col>
        </Row>

        <Row>
          <Col>
            <Row className={'d-none d-lg-flex border-bottom-dark-gray py-8'}>
              <Col className={'d-none d-lg-block col-lg-2 text-fs-6 m-0'}>
                Benefit
              </Col>
              <Col className={'col-lg-2 ps-6 m-0'}>
                <span className={'text-fs-6 ms-11'}>Deduct Tax</span>
              </Col>
              <Col className={'col-auto col-1 col-lg-2 text-fs-6 m-0'}>
                <span className={'text-fs-6'}>Last Payment Details</span>
              </Col>
              <Col className={'col-auto col-lg-2 text-fs-6 m-0'}>
                <span className={'text-fs-6'}>Outstanding Balances</span>
              </Col>
              <Col className={'col-lg-2 text-fs-6 m-0'}>
                <span className={'text-fs-6'}>Approx Remaining Payments</span>
              </Col>
              <Col className={'col-auto col-lg-2 text-fs-6 m-0'}>
                <span className={'text-fs-6'}></span>
              </Col>
            </Row>

            <Row
              className={
                'striped-rows-fixed-children px-8 py-11 px-lg-0 py-lg-8 d-flex flex-lg-row flex-wrap align-items-center border-bottom border-info'
              }
            >
              <Col
                className={
                  'px-0 px-lg-5 col-3 col-lg-2 order-0 h3 text-fs-6 m-0 fw-bold'
                }
              >
                Medical
              </Col>
              <Col
                className={
                  'col-3 col-lg-2 d-lg-flex align-items-start justify-content-lg-center order-1'
                }
              >
                <span className={'d-flex align-items-center h3 text-fs-6 m-0'}>
                  Before-Tax
                </span>
              </Col>
              <Col
                className={
                  'ms-auto m-lg-0 col-auto col-lg-2 order-2 order-lg-5 text-center'
                }
              >
                <div>
                  <Button
                    variant="primary"
                    size="sm"
                    onClick={handleShowMedicalRetroBalance}
                  >
                    View History
                  </Button>
                  <MedicalRetroBalanceHistory
                    show={showMedicalRetroBalance}
                    handleClose={handleCloseMedicalRetroBalance}
                  />
                </div>
              </Col>
              <Col
                className={
                  'd-flex d-lg-block align-items-center col-12 col-lg-2 order-3 py-6 px-5 mt-7 mt-lg-0 py-lg-0 text-end text-lg-center'
                }
              >
                <h2 className={'d-lg-none col-auto h6 text-fs-6 m-0 pb-lg-8'}>
                  Last Payment Details
                </h2>
                <span
                  className={'w-100 text-end text-lg-start h3 text-fs-6 m-0'}
                >
                  $143.83
                  <br />
                  <span className={'text-blue h3 text-fs-6 m-0'}>
                    09/08/2023
                  </span>
                </span>
              </Col>
              <Col
                className={
                  'd-flex d-lg-block align-items-center col-12 col-lg-2 order-4 order-lg-3 py-6 px-5 py-lg-0 text-end text-lg-center'
                }
              >
                <h2 className={'d-lg-none col-auto h6 text-fs-6 m-0 pb-lg-8'}>
                  Outstanding Balances
                </h2>
                <span
                  className={'retro-balance w-100 text-end text-lg-start h3 text-fs-6 m-0'}
                >
                  $287.63
                </span>
              </Col>
              <Col
                className={
                  'd-flex d-lg-block align-items-center col-12 col-lg-2 order-5 order-lg-4 py-6 px-5 py-lg-0 text-end text-lg-center'
                }
              >
                <h2 className={'d-lg-none h6 text-fs-6 m-0'}>
                  Approx Remaining Payments
                </h2>
                <span
                  className={'w-100 text-end text-lg-center h3 text-fs-6 m-0'}
                >
                  2
                </span>
              </Col>
            </Row>
            <Row
              className={
                'striped-rows-fixed-children px-8 py-11 px-lg-0 py-lg-8 d-flex flex-lg-row flex-wrap align-items-center border-top border-info'
              }
            >
              <Col className={'col-lg-6 text-fs-6 m-0'}>
                <span className={'fw-bold text-fs-6'}>Total</span>
              </Col>
              <Col className={'col-lg-2 text-end text-lg-center h3 text-fs-6 m-0'}>
                <span className={'total-retro-balances fw-bold text-fs-6'}>$287.63</span>
              </Col>
            </Row>
          </Col>
        </Row>
      </GenericCard>
    </Container>
  );
};


export default MissedBenefitPayments;
